import { render, staticRenderFns } from "./materialUpload.vue?vue&type=template&id=3092f4e8&scoped=true&"
import script from "./materialUpload.vue?vue&type=script&lang=js&"
export * from "./materialUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3092f4e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/private_library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3092f4e8')) {
      api.createRecord('3092f4e8', component.options)
    } else {
      api.reload('3092f4e8', component.options)
    }
    module.hot.accept("./materialUpload.vue?vue&type=template&id=3092f4e8&scoped=true&", function () {
      api.rerender('3092f4e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/materialUpload.vue"
export default component.exports